/**
 * *******************************************************************************************************************
 * Responsibility - Renders all data and actions related to a design's artwork. 🐺
 * *******************************************************************************
 *
 * @format
 */

import {ResponsiveWidthImageThumbnail} from '../../../shared/responsive_width_image_thumbnail';
import {If, IfElse} from 'frontier-utilities';
import React, {useState} from 'react';

export const TableColumnArtwork = props => {
    const {isPrintedProof, designOrder, onCollapse, shareLink, order} = props;

    const [currentImgSource, setCurrentImageSource] = useState(
        designOrder.design.pressready_thumb_signed_url
    );

    const handleToggleSpotWhiteLayer = () => {
        if (currentImgSource !== designOrder.design.pressready_spotwhite_thumb_signed_url) {
            setCurrentImageSource(designOrder.design.pressready_spotwhite_thumb_signed_url);
        } else {
            setCurrentImageSource(designOrder.design.pressready_thumb_signed_url);
        }
    };

    const handleToggleSimulationLayer = () => {
        if (currentImgSource !== designOrder.design.pressready_simulation_thumb_signed_url) {
            setCurrentImageSource(designOrder.design.pressready_simulation_thumb_signed_url);
        } else {
            setCurrentImageSource(designOrder.design.pressready_thumb_signed_url);
        }
    };

    const isShowingSpotWhite =
        currentImgSource === designOrder.design.pressready_spotwhite_thumb_signed_url;
    const isShowingSimulation =
        currentImgSource === designOrder.design.pressready_simulation_thumb_signed_url;

    return (
        <div className="proof-press-ready-56ht--column proof-press-ready-56ht__artwork">
            <div className="column-56ht__header d-flex align-items-center justify-content-start">
                <h5 className="m-0">Artwork</h5>
                <button
                    onClick={e => {
                        onCollapse(e);
                    }}
                    className="ms-2">
                    <u className="color-accent-primary">{designOrder.expanded ? 'Hide' : 'Show'}</u>
                </button>
            </div>
            <If condition={designOrder.expanded}>
                <div className="column-56ht__thumbnail">
                    {/* spotwhite */}
                    <If
                        condition={
                            designOrder.design.pressready_spotwhite_thumb_key &&
                            order.is_spotwhite_required
                        }>
                        <div
                            className={`column-56ht__spotwhite ${
                                isShowingSpotWhite ? 'spotwhite-on' : ''
                            }`}>
                            <button
                                className={`m-0 ${
                                    designOrder.design.pressready_simulation_thumb_key
                                        ? 'p-0'
                                        : 'pt-0 pb-4 px-0'
                                }`}
                                onClick={handleToggleSpotWhiteLayer}>
                                <IfElse condition={isShowingSpotWhite}>
                                    <span className="fa fa-toggle-on mr-2" />
                                    <span className="fa fa-toggle-off mr-2" />
                                </IfElse>
                                <span>Toggle Spotwhite Layer</span>
                            </button>
                        </div>
                    </If>

                    {/* simulation */}
                    <If condition={designOrder.design.pressready_simulation_thumb_key}>
                        <button
                            className={`column-56ht__simulation m-0 p-0 ${
                                isShowingSimulation ? 'simulation-on' : ''
                            }`}
                            onClick={handleToggleSimulationLayer}>
                            <IfElse condition={isShowingSimulation}>
                                <span className="fa fa-toggle-on mr-2" />
                                <span className="fa fa-toggle-off mr-2" />
                            </IfElse>
                            <span>Toggle Simulation Layer</span>
                        </button>
                    </If>
                    <ResponsiveWidthImageThumbnail
                        currentImgSource={currentImgSource}
                        designOrder={designOrder}
                    />
                </div>
            </If>

            <div
                className={`proof_press_ready-56ht__actions-f-size-name actions-56ht-f-size ms-0 me-auto ${
                    !designOrder.expanded ? 'pt-4' : ''
                }`}>
                <If condition={!isPrintedProof}>
                    <button className="color-accent-primary d-flex align-items-center justify-content-end ms-0 me-auto">
                        <i className="fa fa-eye me-2" />
                        <a href={shareLink} rel="noopener noreferrer" target="_blank">
                            <u>View Full Size</u>
                        </a>
                    </button>
                </If>
            </div>
            <div className="proof_press_ready-56ht__actions-f-size-name ms-0 me-auto">
                <span>File name: {designOrder.customer_filename}</span>
            </div>
        </div>
    );
};
